import { GeneralObject, I18n } from "@vocollege/app";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";
import dayjs from "dayjs";

const getCertificationValue = (
  certified: string | undefined,
  from: string | undefined,
  to: string | undefined
) => {
  if (!certified) {
    return "-";
  }

  const startDate = dayjs(from);
  const endDate = dayjs(to);
  const dateToCheck = dayjs(certified);
  const isInRange =
    (dateToCheck.isAfter(startDate) && dateToCheck.isBefore(endDate)) ||
    dateToCheck.isSame(startDate) ||
    dateToCheck.isSame(endDate);

  if (isInRange) {
    return certified;
  }

  return `${certified} (${I18n.get.statistics.labels.outsideSelectedPeriod})`;
};

export const getExcelData = (
  data: any,
  parsedData: GeneralObject,
  queryFilters: GeneralObject | null
) => {
  if (!data?.statistics) {
    return null;
  }

  const result: DownloadExcelButtonProps = {
    filename: "Statistik_certifieringar",
    sheets: [],
  };

  const commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.statistics.labels.certificationsStatistics,
          },
        ],
      },
      "",
      queryFilters?.from && queryFilters?.to
        ? `${queryFilters.from} - ${queryFilters.to}`
        : "-",
    ],
    [],
  ];

  const summarySheet: Sheet = {
    name: I18n.get.statistics.labels.certifications,
    rows: [...commonHead],
  };

  summarySheet.rows?.push(
    [
      I18n.get.statistics.labels.certifiedRegionalVoCollege,
      "",
      data.statistics.certifiedRegions?.length || 0,
    ],
    [
      I18n.get.statistics.labels.certifiedLocalVoCollege,
      "",
      data.statistics.certifiedLocalColleges?.length || 0,
    ],
    [
      I18n.get.statistics.labels.certifiedEducators,
      "",
      data.statistics.certifiedEducators?.length || 0,
    ],
    [
      I18n.get.statistics.labels.certifiedEducations,
      "",
      data.statistics.certifiedEducations?.length || 0,
    ]
  );

  result.sheets?.push(summarySheet);

  const detailsSheet: Sheet = {
    name: I18n.get.statistics.labels.certificationsStatistics,
    rows: [...commonHead],
  };

  Object.keys(parsedData || {}).forEach((regionKey: string) => {
    const region = parsedData[regionKey];
    detailsSheet.rows?.push([
      region.title,
      "",
      getCertificationValue(region.certified, queryFilters?.from, queryFilters?.to),
    ]);

    region.localColleges?.forEach((localCollege: GeneralObject) => {
      detailsSheet.rows?.push([
        `  ${localCollege.title}`,
        "",
        getCertificationValue(
          localCollege.certified,
          queryFilters?.from,
          queryFilters?.to
        ),
      ]);

      localCollege.educators?.forEach((educator: GeneralObject) => {
        detailsSheet.rows?.push([
          `    ${educator.title}`,
          "",
          getCertificationValue(
            educator.certified,
            queryFilters?.from,
            queryFilters?.to
          ),
        ]);

        educator.educations?.forEach((education: GeneralObject) => {
          detailsSheet.rows?.push([
            `      ${education.education_title}`,
            "",
            getCertificationValue(
              education.education_certified,
              queryFilters?.from,
              queryFilters?.to
            ),
          ]);
        });
      });
    });

    detailsSheet.rows?.push([]);
  });

  result.sheets?.push(detailsSheet);

  return result;
};
